<template>
  <div v-if="visible" class="unsaved-changes-indicator">
    <div class="badge badge-warning p-2">
      <CIcon name="cil-warning" /> Unsaved Changes
      <CButton
        size="sm"
        color="primary"
        class="ml-2"
        @click="handleSaveClick"
        :disabled="isDisabled"
      >
        <CIcon name="cil-save" /> Save Now
      </CButton>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UnsavedChangesIndicator',
  props: {
    visible: {
      type: Boolean,
      default: true
    },
    isDisabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleSaveClick() {
      this.$emit('save-click');
    }
  }
}
</script>

<style scoped>
.unsaved-changes-indicator {
  position: fixed;
  top: 70px;
  right: 20px;
  z-index: 1050;
  animation: pulse 2s infinite;
  box-shadow: 0 2px 8px rgba(0,0,0,0.2);
  border-radius: 4px;
}

@keyframes pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(255, 193, 7, 0.7);
  }
  70% {
    box-shadow: 0 0 0 10px rgba(255, 193, 7, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(255, 193, 7, 0);
  }
}
</style>
